// Mock Data for Mental Health Category

const baseProducts = [
    {
        id: "med-mental-1",
        name: "Sertraline 100mg",
        genericName: "Brand: Zoloft",
        indication: "Depression/Anxiety",
        price: "$20",
        originalPrice: "$200",
        savings: "90%",
        description: "An SSRI antidepressant used to treat major depressive disorder, obsessive-compulsive disorder (OCD), panic disorder, and severe anxiety.",
        dosage: "Taken once daily, in the morning or evening. Do not stop abruptly.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place.",
        sideEffects: "Nausea, dizziness, drowsiness, or dry mouth. May take several weeks to see full effects.",
        category: "Antidepressants (SSRIs)"
    },
    {
        id: "med-mental-2",
        name: "Quetiapine 200mg",
        genericName: "Brand: Seroquel",
        indication: "Schizophrenia/Bipolar",
        price: "$36",
        originalPrice: "$520",
        savings: "93%",
        description: "An atypical antipsychotic prescribed for the treatment of schizophrenia, bipolar disorder, and as an adjunctive treatment for major depressive disorder.",
        dosage: "Typically taken once or twice daily. Often taken at bedtime due to sedating effects.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from light and moisture.",
        sideEffects: "Drowsiness, weight gain, dry mouth, or dizziness upon standing.",
        category: "Antipsychotics"
    },
    {
        id: "med-mental-3",
        name: "Lithium 450mg",
        genericName: "Brand: Eskalith",
        indication: "Bipolar Disorder",
        price: "$12",
        originalPrice: "$100",
        savings: "88%",
        description: "A mood stabilizer used primarily in the treatment of bipolar disorder to prevent and treat manic episodes and reduce the risk of suicide.",
        dosage: "Taken two to three times daily. Strict adherence and regular blood level monitoring are required.",
        packaging: "Contains 100 Extended-Release Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a tightly closed container.",
        sideEffects: "Increased thirst, frequent urination, mild hand tremor, or nausea.",
        category: "Mood Stabilizers"
    },
    {
        id: "med-mental-4",
        name: "Aripiprazole 10mg",
        genericName: "Brand: Abilify",
        indication: "Schizophrenia/Bipolar",
        price: "$48",
        originalPrice: "$680",
        savings: "93%",
        description: "An atypical antipsychotic that helps restore the balance of certain natural chemicals in the brain. Used to treat schizophrenia, bipolar disorder, and Tourette's syndrome.",
        dosage: "Taken once daily, with or without food.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature securely.",
        sideEffects: "Restlessness, weight gain, blurred vision, or sleep problems.",
        category: "Antipsychotics"
    },
    {
        id: "med-mental-5",
        name: "Venlafaxine 150mg",
        genericName: "Brand: Effexor XR",
        indication: "Depression/Anxiety",
        price: "$28",
        originalPrice: "$380",
        savings: "93%",
        description: "An SNRI antidepressant used to treat major depressive disorder, generalized anxiety disorder, and panic disorder by affecting serotonin and norepinephrine.",
        dosage: "Taken once daily with food, usually in the morning or evening. Swallow whole.",
        packaging: "Contains 30 Extended-Release Capsules",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from moisture.",
        sideEffects: "Nausea, sweating, dry mouth, or mild increase in blood pressure.",
        category: "Antidepressants (SNRIs)"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-mental-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Mental Health and Psychiatric Care",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of severe mental health conditions including depression, anxiety, and bipolar disorder. Sourced from WHO-GMP certified facilities.`,
            dosage: "Strictly as prescribed by your psychiatrist.",
            packaging: "Contains 30 Tablets/Capsules",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific psychological or physical side effects. Do not discontinue without medical supervision.",
            category: "General Psychiatric Care"
        });

        dosageCount += 25; // Increase dosage
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const mentalHealthProducts = [...baseProducts, ...generateAlphabetMeds()];

export const mentalHealthHeroData = {
    title: "Mental Health",
    subtitle: "Depression, anxiety, bipolar, and psychiatric medication management",
    description: "Consistent access to affordable, high-quality psychiatric medications is critical for mental wellness. We provide reliable bioequivalent treatments for chronic mental health conditions at up to 93% savings.",
    stats: [
        { number: "40+", label: "Medications" },
        { number: "85%", label: "Average Savings" }
    ]
};

export const mentalHealthCategories = [
    "All Categories",
    "Antidepressants (SSRIs)",
    "Antidepressants (SNRIs)",
    "Antipsychotics",
    "Mood Stabilizers",
    "Anti-anxiety",
    "General Psychiatric Care"
];

export const mentalHealthTrustBadges = [
    { text: "WHO-GMP Certified", icon: "ShieldCheck" },
    { text: "Bioequivalent Potency", icon: "Activity" },
    { text: "Discreet Delivery", icon: "Package" },
    { text: "Verified Pharmacy", icon: "Award" }
];

export const mentalHealthFAQs = [
    {
        question: "Do I need a prescription to order mental health medications?",
        answer: "Yes, strictly. All antidepressants, antipsychotics, and mood stabilizers require a valid prescription from your psychiatrist or treating physician."
    },
    {
        question: "Are generic psychiatric medications as effective as the brand names?",
        answer: "Yes. Our generic mental health medications are sourced from highly regulated, WHO-GMP certified manufacturers and are legally required to be bioequivalent, ensuring identical medicinal effects as the expensive brands."
    },
    {
        question: "Can I safely switch from a brand name to these generics?",
        answer: "Yes, because they share the same active ingredients. However, you should always inform your prescribing doctor when transitioning between medication forms."
    },
    {
        question: "How do you ensure discretion and privacy during shipping?",
        answer: "We understand privacy is paramount. All orders are strictly confidential and shipped in unmarked, secure, and resilient packaging directly to your provided address without compromising clinical data."
    }
];

export const mentalHealthTestimonials = [
    {
        name: "Jessica P.",
        country: "United States",
        savings: "$4,200 annually",
        condition: "Major Depressive Disorder",
        medication: "Venlafaxine",
        text: "When I lost my insurance, I was terrified of going through withdrawal. Pricing here allowed me to maintain my exact dosage regimen without any financial strain."
    },
    {
        name: "Marcus L.",
        country: "United Kingdom",
        savings: "$6,500 annually",
        condition: "Bipolar I Disorder",
        medication: "Quetiapine / Lithium",
        text: "Getting a stable, affordable supply of both Seroquel and Lithium generics was life-changing. The deliveries are incredibly consistent, which is exactly what my condition requires."
    },
    {
        name: "Emily W.",
        country: "Australia",
        savings: "$3,800 annually",
        condition: "General Anxiety Disorder",
        medication: "Sertraline",
        text: "The generic Zoloft I receive is perfect. The team ensures my refills are processed fast so I literally never miss a day. Unbeatable peace of mind."
    }
];

export const mentalHealthSectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Read how individuals maintain their mental wellness and stability using our affordable pharmacy network."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important details regarding the safe ordering of psychiatric and mental health therapies."
    },
    midPageCTA: {
        title: "Seeking a Specific Therapy?",
        description: "Our experts can source a comprehensive range of SSRIs, SNRIs, and atypical antipsychotics. Secure your long-term supply safely.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Request Medicine Price"
    },
    finalCTA: {
        title: "Maintain Your Mental Wellness Today",
        description: "Don't let medication costs disrupt your mental health journey. Secure your reliable, affordable generic treatments now.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Submit Prescription"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
